import { useState } from 'react';
import { Box, Button, Card, Heading, Icon, Tag, Text } from '@zillow/constellation-10';
import { IconTrophyFilled } from '@zillow/constellation-icons';
import { RewardsEnrollmentModal } from '@zg-rentals/rewards-enrollment-modal';
import { useRewardsEnroll } from '@renter-hub/hooks/useRewardsEnroll';
import CoinIcon from './CoinIcon';

type RewardsUpsellCardProps = {
  title: string;
  description?: string;
  ctaText?: string;
  claimablePoints: number;
};

export const RewardsUpsellCard = ({ title, description, ctaText, claimablePoints }: RewardsUpsellCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { enroll, isEnrolling, hasEnrollmentError } = useRewardsEnroll();

  const handleEnroll = async () => {
    try {
      await enroll();
      window.location.href = '/rental/rewards?enrolled=true';
    } catch {
      // Modal displays error state via hasEnrollmentError
    }
  };

  return (
    <>
      <Card elevated={false} css={{ flex: 1, padding: 'default' }}>
        <Box css={{ display: 'flex', gap: 'default', alignItems: 'flex-start' }}>
          <Icon size="lg" css={{ color: 'text.accent.purple.hero' }}>
            <IconTrophyFilled />
          </Icon>
          <Box css={{ display: 'flex', flexDirection: 'column' }}>
            <Heading level={3} textStyle="heading-xs">
              {title}
            </Heading>
            {description && <Text css={{ marginBlockStart: 'tighter' }}>{description}</Text>}
            <Box
              css={{
                display: 'flex',
                flexDirection: { base: 'column', md: 'row' },
                alignItems: { base: 'flex-start', md: 'center' },
                gap: 'default',
                marginBlockStart: 'default',
              }}
            >
              <Button onClick={() => setIsModalOpen(true)}>{ctaText ?? 'Claim your points'}</Button>
              {claimablePoints > 0 && (
                <Tag icon={<CoinIcon />}>
                  <Text css={{ fontWeight: 'normal' }}>
                    Get <strong>{claimablePoints}</strong> bonus points
                  </Text>
                </Tag>
              )}
            </Box>
          </Box>
        </Box>
      </Card>
      <RewardsEnrollmentModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        onEnroll={handleEnroll}
        claimablePoints={claimablePoints}
        maxDollarValue={4000}
        isLoading={isEnrolling}
        hasEnrollmentError={hasEnrollmentError}
        contactCareUrl="mailto:rentpayments@zillow.com"
      />
    </>
  );
};
